import { type ButtonProps, Button } from '@launchpad-ui/components';
import clsx from 'clsx';

import { cellButton } from './styles.css';

/**
 * A Button component styled for use within Cell components.
 * This is a thin wrapper around LaunchPad's Button component with cell-specific styling.
 *
 * @example
 * ```tsx
 * <Cell onClick={() => viewTrace()} buttons={[
 *   <CellButton key="open" size="small" variant="default">Open</CellButton>
 * ]}>
 *   <TextContent text="Trace ID" />
 * </Cell>
 * ```
 */
export const CellButton = ({ className, ...props }: ButtonProps) => {
  return <Button {...props} className={clsx(className, cellButton)} />;
};
